/* src/app/dialog-input/dialog-input.component.scss */
.modal-body {
  color: black;
}
p {
  color: black;
}
input.form-control {
  color: black !important;
  background-color: white !important;
  min-width: 400px;
}
/*# sourceMappingURL=dialog-input.component.css.map */
